<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background-color: #fff">
    <div class=".card-row">
      <div class="card card-1">
        <div class="img1" v-for="(item, index) in docs" :key="index">
          <img style="width: 50px; height: auto; margin-right: 10px" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/report/2024-09-07/7a6db4488be9d94eb628ef159db64da777ef.png" />
          <div>
            <div>{{ item.userName }}</div>
            <div>{{ item.title }}</div>
            <div style="color: #76797e">{{ item.hospital }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card-2">
        <div style="margin-bottom: 1vh" v-for="(item, index) in consult" :key="index">
          <div v-show="item.wxUserId != docId">
            <div>
              <div style="display: flex">
                <div style="padding: 5px 0vw">{{ item.userName }}:</div>
                <div v-show="item.infoType == 1" class="card-3">{{ item.infoDetails }}</div>
                <img v-if="item.infoType == 2" :src="item.infoDetails" class="fixed-width-image" />
                <div v-if="item.infoType == 3" class="pdf-preview-container">
                  <div class="pdf-mini-view" @click="downloadPDF(item)">
                    <iframe v-if="item.infoType == 3" :src="item.infoDetails" width="130px" height="160px" frameborder="0"></iframe>
                    <div class="pdf-overlay">
                      <div class="pdf-icon">📄</div>
                      <div class="download-text">点击下载</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="font-size: 13px; color: rgb(185, 184, 184)">
              {{ item.createTime }}
            </div>
          </div>

          <div v-show="item.wxUserId == docId">
            <div style="display: flex; justify-content: flex-end">
              <div v-show="item.infoType == 1" class="card-4">{{ item.infoDetails }}</div>
              <img v-show="item.infoType == 2" :src="item.infoDetails" />
              <div v-if="item.infoType == 3" class="pdf-preview-container">
                <div class="pdf-mini-view" @click="downloadPDF(item)">
                  <iframe v-if="item.infoType == 3" :src="item.infoDetails" width="130px" height="160px" frameborder="0"></iframe>
                  <div class="pdf-overlay">
                    <div class="pdf-icon">📄</div>
                    <div class="download-text">点击下载</div>
                  </div>
                </div>
              </div>
              <div style="padding: 5px 0vw">:{{ item.userName }}</div>
            </div>
            <div style="font-size: 13px; color: rgb(185, 184, 184); text-align: right">
              {{ item.createTime }}
            </div>
          </div>
        </div>

        <div style="margin-bottom: 1vh"></div>
      </div>
    </div>
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getConsultDoc, getConsultDetail } from '@/api/health/manage'

export default {
  name: 'ThreeCardLayout',
  data() {
    return {
      chatId: '',
      consult: [],
      docs: []
    }
  },
  created() {
    this.chatId = this.$route.query.chatId
    this.docId = this.$route.query.docId
    getConsultDoc(this.chatId).then(res => {
      this.docs = res.data
    })
    getConsultDetail(this.chatId).then(res => {
      this.consult = res.data
      console.log(this.consult)
    })
  },
  mounted() {},
  methods: {
    downloadPDF(item) {
      const link = document.createElement('a')
      link.href = item.infoDetails
      link.download = this.getPDFFileName(item.infoDetails)
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    getPDFFileName(url) {
      if (!url) return 'document.pdf'
      const filename = url.split('/').pop() || 'document.pdf'
      return filename.endsWith('.pdf') ? filename : filename + '.pdf'
    }
  }
}
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  /* padding: 1vw; */
  box-sizing: border-box;
  height: calc(100vh - 70px);
  display: grid;
  grid-template-rows: auto 1fr;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card {
  background: #ededed;
  /* border-radius: 8px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vh 1vw;
  box-sizing: border-box;
}

.card-1 {
  display: flex;
  height: auto;
  overflow-y: auto;
  /* text-align: center; */
  font-size: 14px;
  border-bottom: 1px solid #d5d5d5;
  white-space: nowrap;
}

.img1 {
  display: flex;
  padding: 1vh 1vw;
  background-color: #f0f4fe;
  margin-right: 1vw;
  height: 70px;
}

.card-2 {
  flex: 1;
  overflow-y: auto;
}

.card-3 {
  border: 0px solid red;
  border-radius: 8px;
  margin-left: 0.5vw;
  padding: 5px 15px;
  background-color: #fff;
}

.card-4 {
  border: 0px solid red;
  border-radius: 8px;
  margin-right: 0.5vw;
  padding: 5px 15px;
  background-color: #95ec69;
}
</style>

<style scoped>
.fixed-width-image {
  width: 600px;
  height: auto;
  max-height: 600px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.pdf-preview-container {
  margin-left: 10px;
}

.pdf-mini-view {
  position: relative;
  width: 120px;
  height: 160px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pdf-mini-view:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #409eff;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  transform: scale(0.3);
  transform-origin: 0 0;
  pointer-events: none;
}

.pdf-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.pdf-mini-view:hover .pdf-overlay {
  opacity: 1;
}

.pdf-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.download-text {
  font-size: 12px;
  color: #409eff;
  font-weight: bold;
}
</style>
